import { useEffect, useState } from "react";
import { api } from "./api";
import { ExternalLink } from "lucide-react";

const AdminSources = () => {
  const [sources, setSources] = useState([]);
  useEffect(() => { api.listSources().then((r) => setSources(r.data.sources || [])); }, []);

  const grouped = sources.reduce((acc, s) => {
    (acc[s.category] = acc[s.category] || []).push(s);
    return acc;
  }, {});

  return (
    <div className="space-y-6">
      <div>
        <h1 className="font-display text-3xl md:text-4xl font-bold">Lead Sources</h1>
        <p className="text-white/60 mt-1 text-sm">
          The 16 pre-configured channels where we source shippers, e-commerce brands, and fulfillment prospects.
        </p>
      </div>

      {Object.entries(grouped).map(([cat, items]) => (
        <section key={cat}>
          <div className="text-xs uppercase tracking-widest text-[var(--tt-zam-orange)] font-semibold mb-3">
            {cat}
          </div>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-3">
            {items.map((s) => (
              <div key={s.slug} className="rounded-xl bg-[#0f1512] border border-white/10 p-5">
                <div className="flex items-start justify-between gap-2">
                  <div>
                    <div className="font-semibold text-white">{s.name}</div>
                    <div className="text-[11px] text-white/50 mt-0.5">{s.category}</div>
                  </div>
                  {s.url && (
                    <a href={s.url} target="_blank" rel="noreferrer" className="text-white/50 hover:text-[var(--tt-zam-orange)] transition">
                      <ExternalLink className="h-4 w-4" />
                    </a>
                  )}
                </div>
                <div className="mt-4 grid grid-cols-3 gap-2 text-center">
                  <Stat n={s.lead_count} label="Leads" />
                  <Stat n={s.won_count} label="Won" tone="green" />
                  <Stat n={`${s.conversion}%`} label="Conv." tone="orange" />
                </div>
              </div>
            ))}
          </div>
        </section>
      ))}
    </div>
  );
};

const Stat = ({ n, label, tone }) => (
  <div className="rounded-lg bg-white/5 py-2">
    <div className={`text-lg font-display font-bold ${tone === "green" ? "text-[var(--tt-mint)]" : tone === "orange" ? "text-[var(--tt-zam-orange)]" : "text-white"}`}>{n ?? 0}</div>
    <div className="text-[10px] uppercase tracking-wider text-white/50 mt-0.5">{label}</div>
  </div>
);

export default AdminSources;
